export const apiConstants = {
  manager: 'tasks',
  types: 'task/types',
};
